<template>
  <div class="modal fade" id="maintenance-modal" role="dialog" @click="$emit('close')">
    <div class="modal-dialog modal-lg" @click.stop>
      <div class="modal-content additonal-modal-content text-center">
        <div class="pd-t-20 pd-b-20 pd-l-5 pd-r-5">
          <div v-if="html" v-html="html"></div>
          <div v-else class="flex flex-flow-column flex-content-center text-size-20 pd-l-30 pd-r-30 text-plan-normal gap-10 text-size-20">
            <p class="text-size-28 text-danger">ただいまシステムメンテナンス中です</p>
            <p>
              <span>システムメンテナンスに伴い、サービスを停止させて頂いております。</span>
              <br>
              <span>ご不便をおかけいたしますが、サービス再開後にご利用をお願いいたします。</span>
            </p>
            <p class="text-size-28 font-bold mr-t-20">
              <span>【サービス停止期間】</span>
              <br>
              <span>毎週水曜日 21時00分 ～ 23時30分</span>
            </p>
            <p>
              <span>※メンテナンス期間は予定であり、開始・終了時刻は前後する場合があります。</span>
              <br>
              <span>上記期間以外にもメンテナンスに伴うサービス停止を実施させて頂く場合もございます。</span>
            </p>
          </div>
          <div>
            <button class="btn" @click="$emit('close')">閉じる</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="hasBypassMaintenance" class="btn-bypass" @click.stop="$emit('bypassMaintenance')">
      ==>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    html: {
      type: String,
      default: null
    },
    hasBypassMaintenance: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    $('#maintenance-modal').modal('show')
  }
}
</script>
<style scoped>
.btn-bypass {
  opacity: 0;
  position: absolute;
  bottom: 10px;
  left: 0;
}
.btn-bypass:hover {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/view/warehouses/MaintenanceModal.vue